import React from 'react';

function ArrowSquareLeft(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M4.25 2C3.00736 2 2 3.00736 2 4.25L2 19.75C2 20.9926 3.00736 22 4.25 22L19.75 22C20.9926 22 22 20.9926 22 19.75L22 4.25C22 3.00736 20.9926 2 19.75 2L4.25 2ZM11.9421 7.56715C12.186 7.8114 12.1857 8.20713 11.9415 8.45104L9.00778 11.3806L16.3906 11.3806C16.7357 11.3806 17.0156 11.6604 17.0156 12.0056C17.0156 12.3508 16.7357 12.6306 16.3906 12.6306L9.01135 12.6306L11.9417 15.5604C12.1858 15.8044 12.1859 16.2001 11.9418 16.4442C11.6978 16.6884 11.302 16.6884 11.0579 16.4443L7.23486 12.6221C6.89293 12.2802 6.89309 11.7258 7.23523 11.3842L11.0582 7.56654C11.3024 7.32263 11.6982 7.32291 11.9421 7.56715Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowSquareLeft;
